import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

export default function UnassignConfirmationDialog({
  unassignConfirmDialog,
  clientToUnassign,
  onUnassignCancel,
  onUnassignConfirm,
}) {
  return (
    <Dialog open={unassignConfirmDialog} onClose={onUnassignCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Unassignment</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to unassign <strong>{clientToUnassign?.practice_name}</strong> from{' '}
          <strong>
            {clientToUnassign?.assigned_employee?.first_name} {clientToUnassign?.assigned_employee?.last_name}
          </strong>
          ?
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
          This action will end the current assignment relationship.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onUnassignCancel}>Cancel</Button>
        <Button onClick={onUnassignConfirm} variant="contained" color="error">
          Unassign
        </Button>
      </DialogActions>
    </Dialog>
  );
}
